import React from 'react';
import TitanDialog from '../Titan/TitanDialog';
import TextField from '@mui/material/TextField';
import LabelPrinterService from '../../services/LabelPrinterService';
import REGEXPS from '../../constants/regexps';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import OrganizationService from '../../services/OrganizationService';
import { useAuth0 } from '../Authentication/Auth0';

export default function LabelPrinterDialog(props) {
  const { onClose, onSave, labelPrinter } = props;
  const { isSuperAdmin } = useAuth0();

  const [name, setName] = React.useState(labelPrinter ? labelPrinter.name : '');
  const [nameError, setNameError] = React.useState(false);
  const [organizationId, setOrganizationId] = React.useState(
    labelPrinter ? labelPrinter.organizationId : props.organizationId
  );
  const [organizations, setOrganizations] = React.useState([]);

  const onChangeName = e => {
    setName(e.target.value);
    setNameError(!REGEXPS.IOT_THING_NAME.test(e.target.value));
  };

  const handleSave = async () => {
    const data = {
      name,
      organizationId
    };

    let response;

    if (labelPrinter) {
      response = await LabelPrinterService.updatePrinter(labelPrinter.id, data);
    } else {
      response = await LabelPrinterService.createPrinter(data);
    }

    onSave(response);
  };

  React.useEffect(() => {
    if (isSuperAdmin) {
      OrganizationService.getOrganizations().then(response =>
        setOrganizations(response.data)
      );
    }
  }, []);

  return (
    <TitanDialog
      title={`${labelPrinter ? 'Edit' : 'Add'} Label Printer`}
      onClose={onClose}
      onSave={handleSave}
      isValid={!nameError && name.length !== 0 && organizationId}
      successSaveMessage={`Label printer ${
        labelPrinter ? 'update' : 'created'
      }`}
    >
      <TextField
        required
        label="Name"
        placeholder="Name"
        value={name}
        onChange={onChangeName}
        fullWidth
        margin="normal"
        error={nameError}
        helperText="only alphanumeric characters and/or the following: -_:"
      />
      {isSuperAdmin && (
        <FormControl required fullWidth margin="dense">
          <InputLabel>Organization</InputLabel>
          <Select
            value={organizationId}
            onChange={e => setOrganizationId(e.target.value)}
          >
            {organizations &&
              organizations.map(organization => (
                <MenuItem key={organization.id} value={organization.id}>
                  {organization.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}
    </TitanDialog>
  );
}
